import { Stack, Typography } from '@mui/joy';
import { PencilSimpleLine, TrashSimple } from '@phosphor-icons/react';

import { useAgGridTableContext } from 'core/states';
import {
  RemovePricingProfileRulesButton,
  UpsertPricingProfileRuleButton,
} from 'pricing/components';
import { PricingProfileRuleStructureType, PricingProfileRuleType } from 'pricing/enums';
import { IPricingProfile, IPricingProfileRule } from 'pricing/types';
import { Color, Direction, Level } from 'theme/enums';

interface IProps {
  pricingProfile: IPricingProfile;
  data: IPricingProfileRule;
  isEditable?: boolean;
}

export const ActionsCell = ({ pricingProfile, data, isEditable = true }: IProps) => {
  const { gridApi } = useAgGridTableContext();

  const refreshTable = () => {
    gridApi?.refreshServerSide();
  };

  const type =
    data.structureType === PricingProfileRuleStructureType.MARGIN
      ? PricingProfileRuleType.MARGIN
      : PricingProfileRuleType.DISCOUNT;

  return (
    <Stack direction={Direction.ROW} gap={1}>
      <UpsertPricingProfileRuleButton
        pricingProfile={pricingProfile}
        type={type}
        rule={data}
        buttonElement={
          <Typography
            color={isEditable ? Color.PRIMARY : Color.NEUTRAL}
            level={Level.BODY_SM}
            sx={{ cursor: isEditable ? 'pointer' : 'not-allowed', opacity: isEditable ? 1 : 0.5 }}
          >
            <PencilSimpleLine />
          </Typography>
        }
        onSubmitSuccess={refreshTable}
        onRemoveSuccess={refreshTable}
        disabled={!isEditable}
      />

      <RemovePricingProfileRulesButton
        pricingProfileRules={[data]}
        buttonElement={
          <Typography
            color={isEditable ? Color.DANGER : Color.NEUTRAL}
            level={Level.BODY_SM}
            sx={{ cursor: isEditable ? 'pointer' : 'not-allowed', opacity: isEditable ? 1 : 0.5 }}
          >
            <TrashSimple />
          </Typography>
        }
        onRemoveSuccess={refreshTable}
        disabled={!isEditable}
      />
    </Stack>
  );
};
